import React from 'react'
import ProViewField from '../../components/common/ProViewField';
import _ from 'lodash'

const ProViewBedDetailsForm = ({formModel, closeSideBar})=>{   
    const getCommasaperated = (key) => {
        if(formModel[key] && formModel[key].length > 0){
            return formModel[key].map(value => value.name).join(", ");
        }
        return '';
    }
    const getStaffCommasaperated = (key) => {
        if(formModel[key] && formModel[key].length > 0){
            return formModel[key].map(value => value.firstName +' '+ value.lastName).join(", ");
        }
        return '';
    }
    return <div>
                <ProViewField labelText="Location" value={formModel.location.name}></ProViewField>  
                <ProViewField labelText="Building" value={formModel.building.name}></ProViewField> 
                <ProViewField labelText="Room" value={formModel.room.name}></ProViewField>  
                <ProViewField labelText="Bed Name" value={formModel.name}></ProViewField> 
                <ProViewField labelText="Status" value={_.get(formModel.bedStatus,"name") || ""}></ProViewField>  
                <ProViewField labelText="Type" value={_.get(formModel.bedType, "name") || ""}></ProViewField> 
                <ProViewField labelText="Occupancy Status" value={_.get(formModel.occupancyStatus, "name") || ""}></ProViewField>  
                <ProViewField labelText="Reservation Status" value={_.get(formModel.reservationStatus, "name") || ""}></ProViewField> 
                <ProViewField labelText="Tags" value={getCommasaperated('bedTags')}></ProViewField>  
                <ProViewField labelText="Staff" value={getStaffCommasaperated('bedMngmtStaffDetails')}></ProViewField> 
                <ProViewField labelText="Note" value={formModel.note}></ProViewField> 
         </div>

}


export default ProViewBedDetailsForm;